export default __webpack_public_path__ + "static/media/x-solid.b081ba13.svg";